import { get, post, put, del } from '../util/http';
import { ENDPOINTS } from '../util/endpoints';

export const roomService = {
  create:      (data)             => post(ENDPOINTS.rooms.list, data),
  update:      (id, data)         => put(ENDPOINTS.rooms.byId(id), data),
  remove:      (id)               => del(ENDPOINTS.rooms.byId(id)),
  getUsers:    (id)               => get(ENDPOINTS.rooms.users(id)),
  assignUser:  (data)             => post(ENDPOINTS.rooms.assignUser, data),
  unassignUser:(params)           => del(ENDPOINTS.rooms.unassignUser, { params }),
};
